/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetInvoicesRequestPage
 */
export interface GetInvoicesRequestPage {
}

/**
 * Check if a given object implements the GetInvoicesRequestPage interface.
 */
export function instanceOfGetInvoicesRequestPage(value: object): value is GetInvoicesRequestPage {
    return true;
}

export function GetInvoicesRequestPageFromJSON(json: any): GetInvoicesRequestPage {
    return GetInvoicesRequestPageFromJSONTyped(json, false);
}

export function GetInvoicesRequestPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInvoicesRequestPage {
    return json;
}

export function GetInvoicesRequestPageToJSON(json: any): GetInvoicesRequestPage {
    return GetInvoicesRequestPageToJSONTyped(json, false);
}

export function GetInvoicesRequestPageToJSONTyped(value?: GetInvoicesRequestPage | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

